import { Components, Theme } from "@mui/material"

export const MuiTooltip: Components<Theme>["MuiTooltip"] = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      backgroundColor: theme.palette.secondary.main,
    }),
  },
}
